// extracted by mini-css-extract-plugin
export default {"bounce":"P_dw","loading":"P_dx","logo-mark-bounce-right":"P_dy","logo-mark-bounce-left":"P_dz"};